//ADDITIONAL_DEPENDENCIES: site/facebook-pixel-loader

import axios from "axios";
import type from '@plaudit/analytics'; // This is necessary to make the rest of the project build.

declare global {
	interface Window {
		load_hfh_facebook_conversion_api_js_data?: {ajaxurl: string, nonce: string},
		HfhFacebook?: HfhFacebookHelper
	}
}

export type HfhFacebookHelper = {
	isReady(): boolean,
	generateEventId(eventName: any): string,
	triggerViewContentEvent(contentName: any): void,
	triggerHeroCompleteRegistrationEvent(em: any, ph: any): void,
	triggerAffiliateCompleteRegistrationEvent(em: any, ph: any): void,
	triggerCompleteRegistrationEvent(contentCategory: any, contentName: any, signupType: any, em: any, ph: any): void
}

// Object with helper methods for HFH Facebook Pixel events and Conversion API
export default window.HfhFacebook ?? (window.HfhFacebook = {
	isReady() {
		return !!window.fbq;
	},

	/**
	 * Generate a unique event id and return it.  Also stores it in a
	 * cookie.  The cookie name will have 'hfhFacebookEventId_' prepended
	 * to the eventName passed in like this:
	 *
	 *      hfhFacebookEventId_[eventName]
	 */
	generateEventId(eventName) {
		const array = new Uint32Array(3);
		crypto.getRandomValues(array);
		return eventName + '.' + Date.now() + '.' + array.join('');
	},
	triggerViewContentEvent(contentName) {
		const eventName = 'ViewContent';
		const eventId = this.generateEventId(eventName);

		window.fbq?.('track', eventName, {
			content_name: contentName,
			content_type: 'page'
		}, {
			eventID: eventId
		});

		if (!window.load_hfh_facebook_conversion_api_js_data) {
			return;
		}

		// Send Event
		const data = new FormData();
		data.append('action', 'send_hfh_facebook_event');
		data.append('nonce', window.load_hfh_facebook_conversion_api_js_data.nonce);
		data.append('eventName', eventName);
		data.append('eventId', eventId);
		data.append('contentName', contentName);

		axios.post(window.load_hfh_facebook_conversion_api_js_data.ajaxurl, data, {
			headers: {
				'Content-Type': 'multipart/form-data'
			},
			withCredentials: true
		}).then(function (response) {
			// console.log(response.data);
		}).catch(function (error) {
			console.log(error);
		});
	},

	triggerHeroCompleteRegistrationEvent(em, ph) {
		this.triggerCompleteRegistrationEvent('Hero Signup', 'Hero Registration Success', 'hero', em, ph);
	},

	triggerAffiliateCompleteRegistrationEvent(em, ph) {
		this.triggerCompleteRegistrationEvent('Affiliate Schedule', 'Affiliate Schedule View', 'affiliate', em, ph);
	},

	triggerCompleteRegistrationEvent(contentCategory, contentName, signupType, em, ph) {
		const eventName = 'CompleteRegistration';
		const eventId = this.generateEventId(eventName);

		window.fbq?.('track', eventName, {
			content_category: contentCategory,
			content_name: contentName,
			status: true
		}, {
			eventID: eventId
		});

		if (!window.load_hfh_facebook_conversion_api_js_data) {
			return;
		}
		// Send Event
		const data = new FormData();
		data.append('action', 'send_hfh_facebook_event');
		data.append('nonce', window.load_hfh_facebook_conversion_api_js_data.nonce);
		data.append('eventName', eventName);
		data.append('eventId', eventId);
		data.append('signupType', signupType);
		data.append('em', em)
		data.append('ph', ph)

		axios.post(window.load_hfh_facebook_conversion_api_js_data.ajaxurl, data, {
			headers: {
				'Content-Type': 'multipart/form-data'
			},
			withCredentials: true
		}).then(function (response) {
			// console.log(response.data);
		}).catch(function (error) {
			console.log(error);
		});
	}
});
